import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const RemoteAssistance = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main pt-4 pb-5">
        <Container className="py-5">
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Remote Assistance</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Row>
            <Col md={3} xl={3} className="px-sm-0 px-xs-0">
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Faq_Cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9} className="px-5 px-sm-0 Shipping_Card_wrapper">
              <Card className=" Shipping_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Remote Assistance Available </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4">
                  <div className="Shipping_Card_text">
                    <p className="text_muted">
                      Remote assistance refers to a connection that is used to
                      provide technical support from a distance. In this
                      scenario, a user who is sitting at his or her computer can
                      invite our technician to see what is happening on their
                      screen remotely. The remote user receives an invitation
                      from the host and cannot log in without responding to it,
                      these invitations expire once the remote application is
                      exited.
                      <br />
                      <br />
                      Our support team will breifly share control of the host
                      computer, with the sole purpose of getting your software
                      installed correctly. This process can be extremely helpful
                      for users who cannot understand the instalation guide PDF
                      in their account area. This also helps our IT
                      professionals who can install your software from a
                      distance, within moments. <br />
                      <br />
                      Click on the chat icon on the bottom right corner of this
                      screen to learn more.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default RemoteAssistance;
